// List
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// TODO Renders node with correct class name

const Ul = styled.ul`
  padding-left:30px;
  padding-bottom: 20px;
  li {
    margin-bottom: 10px;
    @media(min-width: 460px) {
      line-height: 1.4;
    }
  }
  li::before {
    content: "◼︎"; color: rgb(51, 173, 14);
    display: inline-block; width: 1.3em;
    margin-left: -1.3em}

`;

function List({ className = "", ...props }) {
  const classNames = [ "common-list uk-position-relative uk-flex uk-flex-column uk-flex-center uk-background-fixed uk-background-top-center", className ].join(" ");

  const items = props.items;

  const listItems = items.map((item) =>
    <li key={ item.toString() }>{ item }</li>

  );
  return (
    <Ul className={ classNames }>
      {listItems}
    </Ul>
  );
}
List.defaultProps = {
  items: []
};
List.propTypes = {
  item: PropTypes.func,
  items: PropTypes.array,
  className: PropTypes.any
};

export default List;


// WEBPACK FOOTER //
// ./src/features/common/List.js